import { ReactNode } from "react";

import { ViewContent2 } from "@/components/layout/ViewContent";
import { ViewTitle2 } from "@/components/layout/ViewTitle";

import { ProfileSkeleton } from "./components/ProfileSkeleton";

type MyProfileProps = {
  asideContent: ReactNode;
  isLoading: boolean;
  renderMainContent: () => ReactNode;
};

export function MyProfile({ asideContent, isLoading, renderMainContent }: MyProfileProps) {
  if (isLoading)
    return (
      <ViewContent2>
        <ViewTitle2>My Profile</ViewTitle2>
        <ProfileSkeleton />
      </ViewContent2>
    );

  return (
    <ViewContent2>
      <ViewTitle2>My Profile</ViewTitle2>

      <div data-public="true">
        <div className="tw:flex tw:flex-col tw:gap-4 tw:md:flex-row">
          <aside className="tw:md:w-1/4">{asideContent}</aside>

          <div className="tw:flex tw:flex-col tw:gap-4 tw:md:w-3/4">{renderMainContent()}</div>
        </div>
      </div>
    </ViewContent2>
  );
}
